webpackJsonp([231148046025140],{

/***/ 1203:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AdminTag","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMING_SOON"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ENABLED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-admin-tag-b6f7611e8ea26bdf400f.js